import { render, staticRenderFns } from "./LogoAddress.vue?vue&type=template&id=296ca60c"
import script from "./LogoAddress.vue?vue&type=script&lang=js"
export * from "./LogoAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports